// loadCart() {
// 	return api.orders.getCart().then(res => {
// 		this.allCarts = res
// 		this.allCarts = this.allCarts[0].cases[0].tickets
// 	});
// }

// console.log('allCarts');
// console.log(this.allCarts);

// console.log('orderCarts');
// console.log(order.carts);


export class EventOrderModel {
	constructor() {
		this.initOrder();
	}

	initOrder() {
		this.id = null;
		this.amount = 0;
		this.carts = [];
		this.additionalServices = [];
	}

	getOrderData() {
		return {
			id: this.id,
			amount: this.amount,
			carts: this.carts,
		};
	}

	/**
	 * Загружает и валидирует (навзвания свойств, список билетов, сумму)
	 * Если передать id мерпориятия то будет сортировать под конкретное мероприятие! т.к в заказе могут быть несколько мероприятии
	 * @param order {Object} - Объект заказа полученный из сервера
	 * {
	 *   id,
	 *   carts {Array} - [{ event_id, ... }, ... ]
	 * }
	 * @param eventId
	 *
	 * @return {Object}
	 */
	validateOrderData(order, eventId) {
		console.log(order);
		
		if (!Array.isArray(order.carts)) throw new Error("Не удалось валидировать данные билетов!");		

		this.id = order.id;
		this.carts = order.carts;
		this.amount = this.updateOrderAmount();
		
		return this.getOrderData();
	}

	updateOrderAmount(amount) {
		if (amount) return (this.amount = amount);

		this.amount = 0;
		$.each(this.carts, (i, cart) => {
			this.amount += cart.price;
		});

		let sumAdditionalTicketsPrice = this.carts.reduce((acc, item) => {
			// console.log(item);
			
			if (Array.isArray(item.additionalTickets)) {
					item.additionalTickets.forEach(additionalTicket => {
							acc += additionalTicket.price;
					});
			}

			return acc;
		}, 0);

		return this.amount += sumAdditionalTicketsPrice;
	}

	addActiveCarts(carts) {
		$.each(carts, (i, cart) => this.carts.push(cart));

		return this.updateOrderAmount();
	}

	removeActiveCarts(carts) {
		$.each(carts, (i, cart) => {
			this.carts = this.carts.filter(el => el.uid !== cart.uid);
		});

		return this.updateOrderAmount();
	}
}
